module.exports = __webpack_public_path__ + "img/20190629103223773.b5fb53c5.png";